import { render, staticRenderFns } from "./modal-album-set.vue?vue&type=template&id=0327ca36&"
import script from "./modal-album-set.vue?vue&type=script&lang=js&"
export * from "./modal-album-set.vue?vue&type=script&lang=js&"
import style0 from "./modal-album-set.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports